import { FC } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router";

import { Home, PharmacyList, NotFound, PharmacyDetails, PharmacyJourney, PharmacyJourneyList, PharmacyJourneyDetails } from "@/basic/pages";


import { URL, FORMULARY_URL } from "./urls";

/**
 * The Enrollment routes.
 */

export const BasicRoutes: FC = (): JSX.Element => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path={URL.HOME} element={<Home />} />
        <Route path={URL.PHARMACY_LIST} element={<PharmacyList />} />
        <Route path={URL.PHARMACY_DETAILS} element={<PharmacyDetails />} />

        <Route path={FORMULARY_URL.HOME} element={<PharmacyJourney />} />
        <Route path={FORMULARY_URL.PHARMACY_LIST} element={<PharmacyJourneyList />} />
        <Route path={FORMULARY_URL.PHARMACY_DETAILS} element={<PharmacyJourneyDetails />} />
        <Route path={URL.NOT_FOUND} element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </BrowserRouter>
  );
};
